import {
  getDefaultActions,
} from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ListActionItemMenuItems/DefaultActionItemMenuItems';
import {
  getAccountOpeningActions,
} from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem/ListItem/ListActionItemMenuItems/ActionItemMenuItems';

const ListActionItemMenuItems = (
  resource,
  hidden,
  toggleHide,
  completed,
  userCanUpdateActionItem,
  handleEditTask,
  isAccountAi,
  isAccountFundingAi,
  isAccountRetitlingAi,
  markAsComplete,
  actionItemOnClick,
  handleQuestionOnClick,
  onClose,
) => {
  const defaultActionItems = getDefaultActions(
    resource,
    hidden,
    toggleHide,
    completed,
    userCanUpdateActionItem,
    handleEditTask,
    isAccountAi,
    markAsComplete,
    onClose,
  );

  return getAccountOpeningActions(
    resource,
    completed,
    userCanUpdateActionItem,
    isAccountAi,
    isAccountFundingAi,
    isAccountRetitlingAi,
    actionItemOnClick,
    handleQuestionOnClick,
    onClose,
    defaultActionItems,
  );
};

export default ListActionItemMenuItems;
